import './styles/corporate_info.scss';

import React, { useEffect, useState, useContext, useMemo } from "react";
import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import Chip from "@mui/material/Chip";
import Collapse from "@mui/material/Collapse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CorporateMemberController from "./Controller/corporate_membership_controller.ts";
import InvoiceController from "./Controller/invoice_controller.ts";
import MemberUserController from "./Controller/member_user_controller.ts";
import { notification } from "antd";
import { useSearchParams } from "react-router-dom";
import { HolderOutlined } from "@ant-design/icons";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button as Buttons, Table } from "antd";
import { pdf } from "@react-pdf/renderer";

import { Tag, Typography as Typographys } from "antd";
import TableContainer from "@mui/material/TableContainer";
import TableMUI from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import MembershipFormPDF from "./pdf/application-form-pdf.tsx";

//components
import SelectionBox from '../../i-components/SelectionBox.tsx';

//classes
import SelectionList from '../../i-classes/selectionList.tsx';

const { Text } = Typographys;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <div {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: "rotate(0deg)",
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: "rotate(180deg)",
      },
    },
  ],
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Dashboard = () => {
  // expand button
  const [expanded, setExpanded] = React.useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  // tabs handle change
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // notification
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, msg) => {
    api[type]({
      message: msg,
      description: desc,
    });
  };

  const [shouldRefetchData, setShouldRefetchData] = useState(false);
  const [data, setData] = useState([]); //payment is default during registration eg: registration fee & first year annual subscription fee
  const [dataMemberUser, setDataMemberUser] = useState([]); //get the information of representatives accounts
  const [dataEventInvoice, setDataEventInvoice] = useState([]); //event joined invoices
  const [subRowsMP, setSubRowsMP] = useState([]);
  const [searchParams] = useSearchParams();
  const membership_registrationID = searchParams.get(
    "membership_registrationID"
  );
  const [dataSourceMP, setDataSourceMP] = React.useState([]);
  const [dataSourceEP, setDataSourceEP] = React.useState([]);
  const [dataSourceMember, setDataSourceMember] = React.useState([]);
  const [stateSelectionLists, SetStateSelectionLists] = React.useState([
    {"key": "Johor", "value": "Johor"},
    {"key": "Kedah", "value": "Kedah"},
    {"key": "Kelantan", "value": "Kelantan"},
    {"key": "Malacca", "value": "Malacca"},
    {"key": "Negeri Sembilan", "value": "Negeri Sembilan"},
    {"key": "Overseas", "value": "Overseas"},
    {"key": "Pahang", "value": "Pahang"},
    {"key": "Penang", "value": "Penang"},
    {"key": "Perak", "value": "Perak"},
    {"key": "Pulau Pinang", "value": "Pulau Pinang"},
    {"key": "Sabah", "value": "Sabah"},
    {"key": "Sarawak", "value": "Sarawak"},
    {"key": "Selangor", "value": "Selangor"},
    {"key": "Terengganu", "value": "Terengganu"},
    {"key": "WP-KL", "value": "WP-KL"},
    {"key": "WP-Labuan", "value": "WP-Labuan"},
    {"key": "WP-Putrajaya", "value": "WP-Putrajaya"}
  ]);
  const [mallLocation, SetMallLocation] = React.useState('');
  const [companyRegisteredAddressState, SetCompanyRegisteredAddressState] = React.useState('');

  //watchers
  //watch for data update mallLocation & registeredAddressState
  useEffect(() => {
    SetMallLocation(data.mall_location);
    SetCompanyRegisteredAddressState(data.company_registered_address_state);
  }, [data]);

  useEffect(() => {
    if (membership_registrationID) {
      const payload = new FormData();
      payload.append("membership_registrationID", membership_registrationID);

      CorporateMemberController.getInfo(payload)
        .then((response) => {
          console.log(response)
          setData(response);
          const payload1 = { memberID: response.memberID };
          CorporateMemberController.getContractPaymentInfo(payload1)
            .then((response) => {
              console.log(response);
              const rowPayment = response.map((item, index) => {
                return {
                  key: index,
                  paymentID: item.paymentID,
                  payment_status: item.payment_status,
                  invoice_no: item.invoice_no,
                };
              });

              setDataSourceMP(rowPayment);

              // Collect payment items with paymentID and flatten the array
              const paymentItems = response.flatMap((element) =>
                element.payment_items.map((item) => ({
                  ...item, // Spread payment item properties
                  paymentID: element.paymentID, // Include paymentID
                }))
              );

              setSubRowsMP(paymentItems); // Update state
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });

          MemberUserController.getMemberUser(payload1).then((response) => {
            setDataMemberUser(response);

            const dataSourceMember = response.map((item, index) => {
              return {
                key: index,
                name: item.name,
                nric: item.nric,
                email: item.email,
                address: item.address,
              };
            });
            setDataSourceMember(dataSourceMember);
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }

    InvoiceController.getEventInvoice().then((response) => {
      setDataEventInvoice(response);
    });
  }, [membership_registrationID, data.memberID, shouldRefetchData]);

  useEffect(() => {
    const userIDs = dataMemberUser.map((item, index) => item.userID);
    const events_data = dataEventInvoice
      ? dataEventInvoice
          .filter((event) => {
            return event.beneficiary.some((item) =>
              userIDs.includes(item.userID)
            );
          })
          .map((event, index) => {
            // Customize the returned data structure

            return {
              key: index,
              paymentID: event.paymentID,
              invoice_no: event.invoice_no,
              payment_status: event.payment_status,
              normal_rate: event.event_fee.normal_rate,
              early_bird_rate: event.event_fee.early_bird_rate,
              latecomer_rate: event.event_fee.latecomer_rate,
              group_discount_rate: event.event_fee.group_discount_rate,
              min_group_discount_pax: event.event_fee.min_group_discount_pax,
              matchingUsers: event.beneficiary.filter((item) =>
                userIDs.includes(item.userID)
              ),
              event_name: event.event_name,
            };
          })
      : [];
    setDataSourceEP(events_data);
  }, [subRowsMP, dataEventInvoice, dataMemberUser]);

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      company_name: "",
      company_registered_address: "",
      company_registered_address_state: "",
      mall_location: "",
      company_number: "",
      company_correspondence_address: "",
      name_of_building: "",
      website: "",
      date_of_incorporation: "",
      company_telephone_number: "",
      company_fax: "",
      company_email: "",
      gross_built_up_area: "",
      nett_lettable_area: "",
      e_invoice_pin: ""
    },
  });

  useEffect(() => {
    if (data) {
      reset({
        company_name: data.company_name || "",
        company_registered_address: data.company_registered_address || "",
        company_registered_address_state: data.company_registered_address_state || "",
        mall_location: data.mall_location || "",
        company_number: data.company_number || "",
        company_correspondence_address:
          data.company_correspondence_address || "",
        name_of_building: data.name_of_building || "",
        website: data.website || "",
        date_of_incorporation: data.date_of_incorporation || "",
        company_telephone_number: data.company_telephone_number || "",
        company_fax: data.company_fax || "",
        company_email: data.company_email || "",
        gross_built_up_area: data.gross_built_up_area || "",
        nett_lettable_area: data.nett_lettable_area || "",
        e_invoice_pin: data.e_invoice_pin || ""
      });
    }
  }, [data, reset]);

  const userID = localStorage.getItem('userID');

  const onSubmit = async (data) => {
    data['company_registered_address_state'] = companyRegisteredAddressState;
    data['mall_location'] = mallLocation;

    const payload = {
      ID: membership_registrationID,
      data: data,
      userID: userID,
    };
    if (Object.keys(errors).length > 0) {
      console.log("Form has errors:", errors);
      return; // Prevent submission if there are errors
    }

    try {
      const response = await CorporateMemberController.saveRow(payload);
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Your data has been saved successfully!",
          "Success"
        );
        setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
      } else {
        console.log(response);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  const handleGeneratePDF = async (membership_registrationID) => {
    try {
      const payload = new FormData();
      payload.append("membership_registrationID", membership_registrationID);

      // console.log(membership_registrationID)
      const data = await CorporateMemberController.getInfo(
        payload
      );

      // console.log(data)

      const blob = await pdf(
        <MembershipFormPDF
          data={data}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");

      // Optional: If you want to revoke the URL after opening it
      // setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (err) {
      console.error("Error generating PDF:", err);
      alert("Failed to generate pdf.\nPlease try again.");
    }
  };

  // ------------------------------------- DRAGGABLE ROW TABLE ------------------------------------------------------------------------
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setDataSourceMP((prevState) => {
        const activeIndex = prevState.findIndex(
          (record) => record.key === active?.id
        );
        const overIndex = prevState.findIndex(
          (record) => record.key === over?.id
        );
        return arrayMove(prevState, activeIndex, overIndex);
      });

      setDataSourceEP((prevState) => {
        const activeIndex = prevState.findIndex(
          (record) => record.key === active?.id
        );
        const overIndex = prevState.findIndex(
          (record) => record.key === over?.id
        );
        return arrayMove(prevState, activeIndex, overIndex);
      });

      setDataSourceMember((prevState) => {
        const activeIndex = prevState.findIndex(
          (record) => record.key === active?.id
        );
        const overIndex = prevState.findIndex(
          (record) => record.key === over?.id
        );
        return arrayMove(prevState, activeIndex, overIndex);
      });
    }
  };

  const RowContext = React.createContext({});
  const DragHandle = () => {
    const { setActivatorNodeRef, listeners } = useContext(RowContext);
    return (
      <Buttons
        type="text"
        size="small"
        icon={<HolderOutlined />}
        style={{
          cursor: "move",
        }}
        ref={setActivatorNodeRef}
        {...listeners}
      />
    );
  };
  const Row = (props) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: props["data-row-key"],
    });
    const style = {
      ...props.style,
      transform: CSS.Translate.toString(transform),
      transition,
      ...(isDragging
        ? {
            position: "relative",
            zIndex: 9999,
          }
        : {}),
    };
    const contextValue = useMemo(
      () => ({
        setActivatorNodeRef,
        listeners,
      }),
      [setActivatorNodeRef, listeners]
    );
    return (
      <RowContext.Provider value={contextValue}>
        <tr {...props} ref={setNodeRef} style={style} {...attributes} />
      </RowContext.Provider>
    );
  };
  // ------------------------------------- DRAGGABLE ROW TABLE ------------------------------------------------------------------------

  // --------------------------------- TABLE MEMBERSHIP PAYMENT -------------------------------------------------------------------------------

  const columnsMP = [
    {
      title: "Items", // Title for the expandable icon column
      dataIndex: "expand", // Placeholder for the expandable column,
      key: "expand",
      width: 5,
    },
    {
      key: "sort",
      align: "center",
      width: 80,
      render: () => <DragHandle />,
    },
    {
      title: "Payment ID",
      dataIndex: "paymentID",
    },
    // {
    //   title: "Invoice No.",
    //   dataIndex: "invoice_no",
    // },
    {
      title: "Status",
      dataIndex: "payment_status",
      render: (payment_status) => {
        if (payment_status === 1) {
          return <Tag color="green">Paid</Tag>;
        } else if (payment_status === 0) {
          return <Tag color="red">Pending</Tag>;
        } else {
          <Tag color="red">Unpaid</Tag>;
        }
      },
    },
  ];

  const expandColumns = [
    {
      title: "Label",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Type",
      key: "type",
      render: (record) => {
        if (record.type === 0) {
          return <Tag color="#2db7f5">Entrance Fee</Tag>;
        } else if (record.type === 1) {
          return <Tag color="#2db7f5">Subscription Fee</Tag>;
        } else if (record.type === 2) {
          return <Tag color="#2db7f5">Renewal Fee</Tag>;
        }
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => {
        return (
          <>
            <Text>RM</Text>{" "}
            {amount?.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </>
        );
      },
    },
  ];

  const expandColumnsEP = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
  ];

  const expandedRowRender = (record) => {
    // ---- membership payment data ------------------
    let totalMP = 0; // State for total

    const paymentID = String(record.paymentID);

    const matchingRowMP = subRowsMP.find(
      (item) => String(item.paymentID) === paymentID
    );

    if (matchingRowMP) {
      const expandDataSource = subRowsMP
        .filter((innerItem) => {
          return innerItem.paymentID === paymentID; // Return the comparison result
        })
        .map((item, index) => ({
          key: index,
          label: item.label,
          description: item.description,
          type: item.type,
          amount: item.amount,
        }));

      const calculatedTotal = subRowsMP
        .filter((innerItem) => {
          return innerItem.paymentID === paymentID; // Return the comparison result
        })
        .reduce((acc, item) => acc + Number(item.amount), 0);
      totalMP = calculatedTotal; // Update total with calculated value

      return (
        <>
          <Table
            columns={expandColumns}
            dataSource={expandDataSource}
            pagination={false}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <TableContainer sx={{ width: "40%" }} component={Paper}>
              <TableMUI aria-label="spanning table">
                <TableBody>
                  <TableRow>
                    <TableCell>Total Excl.SST</TableCell>
                    <TableCell align="right">
                      RM{" "}
                      {totalMP.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>SST 8%</TableCell>
                    <TableCell align="right">RM 0.00</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Total</TableCell>
                    <TableCell align="right">
                      RM{" "}
                      {totalMP.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableMUI>
            </TableContainer>
          </Box>
        </>
      );
    }
    // ---- membership payment data ------------------

    // ---- event beneficiary data -------------------

    const expandDataSourceEP = record.matchingUsers.map((item, index) => ({
      key: index,
      name: item.name,
      email: item.email,
      address: item.address,
    }));

    return (
      <>
        <Table
          columns={expandColumnsEP}
          dataSource={expandDataSourceEP}
          pagination={false}
        />
      </>
    );

    // ---- event beneficiary data -------------------
  };

  // --------------------------------- TABLE MEMBERSHIP PAYMENT -------------------------------------------------------------------------------

  // --------------------------------- TABLE EVENT PAYMENT -------------------------------------------------------------------------------

  const columnsEP = [
    {
      title: "Beneficiary", // Title for the expandable icon column
      dataIndex: "expand", // Placeholder for the expandable column,
      key: "expand1",
      width: 5,
    },
    {
      key: "sort",
      align: "center",
      width: 80,
      render: () => <DragHandle />,
    },
    {
      title: "Payment ID",
      dataIndex: "paymentID",
    },
    {
      title: "Invoice No.",
      dataIndex: "invoice_no",
    },
    {
      title: "Event Name",
      dataIndex: "event_name",
    },
    {
      title: "Status",
      dataIndex: "payment_status",
      render: (payment_status) => {
        if (payment_status === 1) {
          return <Tag color="green">Paid</Tag>;
        } else if (payment_status === 0) {
          return <Tag color="red">Pending</Tag>;
        } else {
          <Tag color="red">Unpaid</Tag>;
        }
      },
    },
  ];

  // --------------------------------- TABLE EVENT PAYMENT -------------------------------------------------------------------------------

  // --------------------------------- TABLE  MEMBERS -------------------------------------------------------------------------------
  const columnsMember = [
    {
      key: "sort",
      align: "center",
      width: 80,
      render: () => <DragHandle />,
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "NRIC",
      dataIndex: "nric",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Address",
      dataIndex: "address",
    },
  ];
  // --------------------------------- TABLE  MEMBERS -------------------------------------------------------------------------------

  return (
    <Box
      className='corporate_info'
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: "100%",
        width: "100vw",
      }}
    >
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {contextHolder}

        <Card variant="outlined">
          <CardContent>
            <Buttons
              type="default"
              color="primary"
              style={{ marginBottom: "10px" }}
              // icon={<WorkspacePremiumIcon />}
              onClick={() => handleGeneratePDF(membership_registrationID)}
            >
              Application Info
            </Buttons>
            <Typography
              gutterBottom
              variant="h6"
              sx={{ color: "text.secondary" }}
            >
              Company
            </Typography>
            <Typography
              variant="h5"
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {data.company_name}
            </Typography>
            <Typography variant="h7" sx={{ color: "text.secondary", mb: 1.5 }}>
              Status:{" "}
              {Number(data.status) === 1 ? (
                <Chip label="Active" color="success" />
              ) : (
                <Chip label="Not Active" color="error" />
              )}
            </Typography>
          </CardContent>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Registered Address:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.company_registered_address}
              </Typography>
            </Grid>

            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Registered Address State:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.company_registered_address_state}
              </Typography>
            </Grid>

            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Mall Location:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.mall_location}
              </Typography>
            </Grid>

            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Correspondence Address:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.company_correspondence_address}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Registered State:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.registered_address_state}
              </Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Mall Location:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.mall_location}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Registered Address:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.company_registered_address}
              </Typography>
            </Grid>

            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Registered Address State:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.company_registered_address_state}
              </Typography>
            </Grid>

            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Mall Location:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.mall_location}
              </Typography>
            </Grid>

            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Correspondence Address:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.company_correspondence_address}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Name of Building:
              </Typography>
              <Typography variant="h7"> {data.name_of_building}</Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Website:
              </Typography>
              <Typography variant="h7"> {data.website}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Date of Incorporation:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.date_of_incorporation}
              </Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Telephone Number:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.company_telephone_number}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Email:
              </Typography>
              <Typography variant="h7"> {data.company_email}</Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Company No.:
              </Typography>
              <Typography variant="h7"> {data.company_number}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Gross Built Up Area:
              </Typography>
              <Typography variant="h7"> {data.gross_built_up_area}</Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Net Lettable Area:
              </Typography>
              <Typography variant="h7"> {data.nett_lettable_area}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Tin No.:
              </Typography>
              <Typography variant="h7"> {data.e_invoice_pin}</Typography>
            </Grid>
            <Grid size={6}>
            </Grid>
          </Grid>


          <CardActions>
            <Button onClick={handleExpandClick} size="small">
              Edit
              <ExpandMore
                expand={expanded}
                aria-expanded={expanded}
                aria-label="show more"
              >
                <ExpandMoreIcon />
              </ExpandMore>
            </Button>
          </CardActions>
        </Card>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <form
              onSubmit={handleSubmit(onSubmit, onInvalid, {
                shouldFocusError: true,
              })}
            >
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Company Name</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("company_name", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Company Number</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("company_number", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Registered Address</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("company_registered_address", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Registered Address State</Typography>
                </Grid>
                <Grid size={8}>
                  {/* <TextInput
                    type="text"
                    {...register("company_registered_address_state", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  /> */}
                  <SelectionBox className='selection-box' selectionList={stateSelectionLists} selectingKey={companyRegisteredAddressState} SetSelectingKey={SetCompanyRegisteredAddressState}/>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Mall Location</Typography>
                </Grid>
                <Grid size={8}>
                  {/* <TextInput
                    type="text"
                    {...register("mall_location", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  /> */}
                  <SelectionBox className='selection-box' selectionList={stateSelectionLists} selectingKey={mallLocation} SetSelectingKey={SetMallLocation}/>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Correspondence Address</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("company_correspondence_address", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Name of Building</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("name_of_building", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Website</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("website", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Date of Incorporation</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("date_of_incorporation", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Telephone Number</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("company_telephone_number", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Fax</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("company_fax", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? errors.company_fax : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Email</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("company_email", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Gross Built Up Area</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("gross_built_up_area", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Net Lettable Area</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("nett_lettable_area", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? errors.nett_lettable_area : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Tin No.</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("e_invoice_pin", {
                    })}
                    onErrorCheck={errors ? errors.e_invoice_pin : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Button
                sx={{
                  backgroundColor: "#d33333",
                }}
                variant="contained"
                type="submit"
              >
                <Typography variant="h6">Save</Typography>
              </Button>
            </form>
          </CardContent>
        </Collapse>

        <Card variant="outlined" sx={{ mt: 6, mb: 6 }}>
          <CardContent>
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Member Records" {...a11yProps(0)} />

                  <Tab label="Payment Records" {...a11yProps(1)} />
                  {/* <Tab label="Invoice Records" {...a11yProps(1)} /> */}
                  <Tab label="Event Records" {...a11yProps(2)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <DndContext
                  modifiers={[restrictToVerticalAxis]}
                  onDragEnd={onDragEnd}
                >
                  <SortableContext
                    items={dataSourceMP.map((i) => i.key)}
                    strategy={verticalListSortingStrategy}
                  >
                    <Table
                      rowKey="key"
                      components={{
                        body: {
                          row: Row,
                        },
                      }}
                      columns={columnsMember}
                      dataSource={dataSourceMember}
                    />
                  </SortableContext>
                </DndContext>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <DndContext
                  modifiers={[restrictToVerticalAxis]}
                  onDragEnd={onDragEnd}
                >
                  <SortableContext
                    items={dataSourceMP.map((i) => i.key)}
                    strategy={verticalListSortingStrategy}
                  >
                    <Table
                      rowKey="key"
                      components={{
                        body: {
                          row: Row,
                        },
                      }}
                      expandable={{
                        expandedRowRender,
                        defaultExpandedRowKeys: ["1"],
                      }}
                      columns={columnsMP}
                      dataSource={dataSourceMP}
                    />
                  </SortableContext>
                </DndContext>
              </CustomTabPanel>

              <CustomTabPanel value={value} index={2}>
                <DndContext
                  modifiers={[restrictToVerticalAxis]}
                  onDragEnd={onDragEnd}
                >
                  <SortableContext
                    items={dataSourceEP.map((i) => i.key)}
                    strategy={verticalListSortingStrategy}
                  >
                    <Table
                      rowKey="key"
                      components={{
                        body: {
                          row: Row,
                        },
                      }}
                      expandable={{
                        expandedRowRender,
                        defaultExpandedRowKeys: ["1"],
                      }}
                      columns={columnsEP}
                      dataSource={dataSourceEP}
                    />
                  </SortableContext>
                </DndContext>
              </CustomTabPanel>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default Dashboard;
